// Selettore lingua dashboard — priorità: localStorage → navigator → it (vedi src/i18n.js).
// `variant="login"`: footer schermata login; valore iniziale = lingua attiva i18n (primo accesso ≈ browser).
import { useTranslation } from "react-i18next";
import { SUPPORTED_LOCALES, normalizeLocale } from "../i18n";

function GlobeIcon({ size = 20 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className="language-selector__globe"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M2 12h20M12 2c2.5 3 3.8 6.5 3.8 10s-1.3 7-3.8 10c-2.5-3-3.8-6.5-3.8-10S9.5 5 12 2z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

const selectStyleBase = {
  padding: "8px 10px",
  borderRadius: 8,
  border: "1px solid #e5e7eb",
  fontSize: 13,
  background: "#fff",
  color: "#374151",
  fontFamily: "var(--font, system-ui, sans-serif)",
};

/**
 * @param {{ variant?: "sidebar" | "login" }} props
 */
export default function LanguageSelector({ variant = "sidebar" }) {
  const { i18n, t } = useTranslation("common");
  const code = normalizeLocale(i18n.language);
  const inputId = variant === "login" ? "carthub-dashboard-lang-login" : "carthub-dashboard-lang";

  if (variant === "login") {
    return (
      <div className="language-selector language-selector--login">
        <div className="language-selector__login-row">
          <GlobeIcon size={22} />
          <select
            id={inputId}
            className="language-selector__select language-selector__select--login"
            value={code}
            onChange={(e) => i18n.changeLanguage(normalizeLocale(e.target.value))}
            aria-label={t("language.label")}
            style={{ ...selectStyleBase, flex: 1, minWidth: 0, width: "100%" }}
          >
            {SUPPORTED_LOCALES.map((lng) => (
              <option key={lng} value={lng}>
                {t(`language.names.${lng}`)}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }

  return (
    <div className="language-selector" style={{ padding: "0 12px 12px" }}>
      <label htmlFor={inputId} style={{ display: "block", fontSize: 11, color: "#9ca3af", marginBottom: 6 }}>
        {t("language.label")}
      </label>
      <select
        id={inputId}
        className="language-selector__select"
        value={code}
        onChange={(e) => i18n.changeLanguage(normalizeLocale(e.target.value))}
        aria-label={t("language.label")}
        style={{ ...selectStyleBase, width: "100%" }}
      >
        {SUPPORTED_LOCALES.map((lng) => (
          <option key={lng} value={lng}>
            {t(`language.names.${lng}`)}
          </option>
        ))}
      </select>
    </div>
  );
}
